import { useEffect } from "react";
import CommonUtils from "../../utils/common"
import { useState } from "react";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import { MdSolarPower } from "react-icons/md";
import { FaQuestion } from "react-icons/fa6";
import { ProgressBar, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const DashElv = ({elv}) => {

    const navigate = useNavigate();
    const UTILS = new CommonUtils();
    const color = elv.x_energieform === "Strom" ? "energo" : elv.x_energieform === "Gas" ? "info" : elv.x_energieform === "Strom-Einspeisung" ? "warning" : "secondary";
    const iconSize = 30;
    const icon = elv.x_energieform === "Strom" ? <SlEnergy /> : elv.x_energieform === "Gas" ? <TbFlame /> : elv.x_energieform === "Strom-Einspeisung" ? <MdSolarPower /> : <FaQuestion />;
    
    const [progress, setProgress] = useState(0);
    const [label, setLabel] = useState("");
    const [isHover, setIsHover] = useState(false);


    useEffect(() => {
        if (elv) {
            var start = new Date(elv.x_belbeg);
            var end = elv.x_datum_vertragsende !== "False" ? new Date(elv.x_datum_vertragsende) : new Date();
            var now = new Date();

            if (elv.x_datum_vertragsende === "False") {
                end = new Date(start);
                end.setDate(start.getDate() + 365);
            }

            const totalTime = end - start;
            const elapsedTime = now - start;
            let percent = (elapsedTime / totalTime) * 100;
            percent = Math.max(0, Math.min(100, percent));

            start = UTILS.dateToEuFormat(start.toDateString());
            if (elv.x_datum_vertragsende === "False") {
                end = "laufend";
            } else {
                end = UTILS.dateToEuFormat(end.toDateString());
            }
            setProgress(percent);
            setLabel(`${start} - ${end}`);
        }
    }, [elv]);


    return (
        <div 
            key={`elvdiv-${elv.id}`}
            className={`border-${color}`}
            onClick={() => navigate(`/dashboard/energieliefervertraege/${elv.id}`)}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            style={isHover? {borderLeft: "3px solid", cursor: "pointer"}: null}
        >
            <Row>
                <div className="d-flex flex-row justify-content-start align-items-center">
                    <div className="text-center" style={{width: "10%"}}>
                        <span className={`text-${color}`} style={{fontSize: iconSize}}>
                            {icon}
                        </span>
                        <br/>
                        <small className={`text-${color}`}>
                            {elv.x_anlage_id[1].split("_")[0].replace(/^0+/, '')}
                        </small>
                    </div>
                    <div className="text-center" style={{width: "90%"}}>
                        <small>{label}</small>
                        <ProgressBar
                            variant={color}
                            now={progress}
                        />
                    </div>
                </div>
            </Row>
        </div>
    )
}
export default DashElv;